import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

interface Sculpture {
  id: number;
  title: string;
  material: string;
  year: string;
  description: string;
  images: string[];
}

const sculptures: Sculpture[] = [
  {
    id: 1,
    title: '刻 / koku 002',
    material: 'Cherry, Concrete',
    year: '2025',
    description: '桜材とコンクリートを組み合わせた作品。有機的な木材の温かみと、無機質なコンクリートの冷たさが対比を生み出し、時間の経過と素材の変化を表現しています。',
    images: [
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/082e6b0c5f4b4d5d2b9e9d598988af3d.jpeg',
      'https://public.readdy.ai/ai/img_res/ff1bbd6d88afdbbf6cb86fef725f1552.jpg',
      'https://readdy.ai/api/search-image?query=abstract%20concrete%20and%20cherry%20wood%20sculpture%20different%20angle%20view%20in%20dark%20atmospheric%20gallery%20space%20contemporary%20minimalist%20art%20installation%20architectural%20forms&width=900&height=600&seq=sculpture1-3&orientation=landscape'
    ]
  },
  {
    id: 2,
    title: 'Organic Flow',
    material: 'Oak Wood',
    year: '2020',
    description: 'オーク材の自然な木目を活かした彫刻作品。素材が持つ有機的な流れを尊重しながら、新しい形態を探求しています。',
    images: [
      'https://readdy.ai/api/search-image?query=abstract%20wooden%20sculpture%20closeup%20showing%20natural%20grain%20texture%20and%20organic%20carved%20forms%20in%20dark%20studio%20setting%20warm%20atmospheric%20lighting%20contemporary%20minimalist%20aesthetic%20natural%20material&width=900&height=600&seq=sculpture2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=oak%20wood%20abstract%20sculpture%20detail%20showing%20natural%20wood%20grain%20patterns%20and%20carved%20organic%20forms%20in%20dark%20minimalist%20setting%20contemporary%20art%20close-up%20texture&width=900&height=600&seq=sculpture2-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=oak%20wood%20abstract%20sculpture%20side%20view%20showing%20flowing%20organic%20forms%20in%20dark%20atmospheric%20gallery%20natural%20material%20contemporary%20minimalist%20art&width=900&height=600&seq=sculpture2-3&orientation=landscape'
    ]
  },
  {
    id: 3,
    title: 'Creation Process',
    material: 'Mixed Media',
    year: '2025',
    description: '制作プロセスそのものを記録した作品。素材と対話しながら形を生み出していく過程を、視覚的に表現しています。',
    images: [
      'https://static.readdy.ai/image/9be18df7882b5fc5208ed7a2c3c10f73/05211cfe1ee92e853ea0c1d11e51f417.jpeg',
      'https://readdy.ai/api/search-image?query=artist%20hands%20working%20on%20abstract%20sculpture%20in%20dark%20studio%20workspace%20with%20tools%20and%20materials%20creative%20process%20documentation%20atmospheric%20lighting%20contemporary%20art%20making%20craftsmanship&width=900&height=600&seq=sculpture3-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=mixed%20media%20abstract%20sculpture%20work%20in%20progress%20showing%20raw%20materials%20and%20creative%20process%20in%20dark%20studio%20setting%20contemporary%20art%20making%20documentation&width=900&height=600&seq=sculpture3-3&orientation=landscape'
    ]
  },
  {
    id: 4,
    title: 'Angular Void',
    material: 'Concrete',
    year: '2022',
    description: '幾何学的な形態とコンクリートの質感が生み出す、空間と余白の関係性を探求した作品です。',
    images: [
      'https://readdy.ai/api/search-image?query=geometric%20abstract%20concrete%20sculpture%20with%20angular%20forms%20in%20dark%20minimalist%20setting%20contemporary%20art%20monochromatic%20aesthetic%20architectural%20design%20clean%20lines&width=600&height=800&seq=sculpture4&orientation=portrait',
      'https://readdy.ai/api/search-image?query=geometric%20concrete%20sculpture%20detail%20showing%20angular%20forms%20and%20textured%20surface%20in%20dark%20atmospheric%20setting%20contemporary%20minimalist%20art%20close-up%20view&width=600&height=800&seq=sculpture4-2&orientation=portrait',
      'https://readdy.ai/api/search-image?query=geometric%20concrete%20sculpture%20alternative%20angle%20showing%20void%20space%20and%20angular%20composition%20in%20dark%20minimalist%20gallery%20contemporary%20architectural%20art&width=600&height=800&seq=sculpture4-3&orientation=portrait'
    ]
  },
  {
    id: 5,
    title: 'Curved Essence',
    material: 'Walnut Wood',
    year: '2018',
    description: 'ウォールナット材の持つ深い色合いと、曲線的なフォルムが調和した作品。素材の本質を引き出すことを目指しています。',
    images: [
      'https://readdy.ai/api/search-image?query=curved%20wooden%20abstract%20sculpture%20with%20smooth%20polished%20surface%20in%20dark%20atmospheric%20gallery%20natural%20wood%20grain%20contemporary%20minimalist%20art%20organic%20shapes&width=600&height=800&seq=sculpture5&orientation=portrait',
      'https://readdy.ai/api/search-image?query=walnut%20wood%20curved%20sculpture%20detail%20showing%20smooth%20polished%20surface%20and%20natural%20grain%20in%20dark%20minimalist%20setting%20contemporary%20art%20close-up%20organic%20forms&width=600&height=800&seq=sculpture5-2&orientation=portrait',
      'https://readdy.ai/api/search-image?query=walnut%20wood%20curved%20sculpture%20different%20angle%20showing%20organic%20flowing%20forms%20in%20dark%20atmospheric%20gallery%20contemporary%20minimalist%20art%20natural%20material&width=600&height=800&seq=sculpture5-3&orientation=portrait'
    ]
  },
  {
    id: 6,
    title: 'Material Fusion',
    material: 'Concrete, Wood',
    year: '2021',
    description: '異なる素材の融合により、新しい表現の可能性を探る実験的な作品です。',
    images: [
      'https://readdy.ai/api/search-image?query=mixed%20media%20abstract%20sculpture%20combining%20concrete%20and%20wood%20materials%20in%20dark%20minimalist%20gallery%20contemporary%20art%20textural%20contrast%20architectural%20forms&width=600&height=800&seq=sculpture6&orientation=portrait',
      'https://readdy.ai/api/search-image?query=concrete%20and%20wood%20mixed%20media%20sculpture%20detail%20showing%20material%20fusion%20and%20textural%20contrast%20in%20dark%20atmospheric%20setting%20contemporary%20art%20close-up&width=600&height=800&seq=sculpture6-2&orientation=portrait',
      'https://readdy.ai/api/search-image?query=concrete%20and%20wood%20abstract%20sculpture%20alternative%20view%20showing%20material%20combination%20in%20dark%20minimalist%20gallery%20contemporary%20architectural%20art&width=600&height=800&seq=sculpture6-3&orientation=portrait'
    ]
  }
];

export default function SculptureDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const sculpture = sculptures.find(s => s.id === Number(id));

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!sculpture) {
    return (
      <div className="bg-[#1a1a1a] text-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-light mb-4">作品が見つかりません</h1>
          <button 
            onClick={() => navigate('/')}
            className="text-[#e8dcc4] hover:underline cursor-pointer"
          >
            ホームに戻る
          </button>
        </div>
      </div>
    );
  }

  const scrollToSection = (id: string) => {
    navigate('/', { state: { scrollTo: id } });
    setMobileMenuOpen(false);
  };

  const handleHomeClick = () => {
    navigate('/');
    setMobileMenuOpen(false);
  };

  const handleBackToWorks = () => {
    navigate('/', { state: { scrollTo: 'sculptures' } });
  };

  return (
    <div className="bg-[#1a1a1a] text-white min-h-screen">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/85 backdrop-blur-sm' : 'bg-transparent'}`}>
        <div className="px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <button onClick={handleHomeClick} className="text-lg md:text-xl font-light tracking-wider cursor-pointer hover:text-[#e8dcc4] transition-colors">
            Dighsk
          </button>
          
          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('about')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              About
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('sculptures')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Sculptures
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('music')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Music
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('video')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Video Works
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('design')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Design
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-light hover:text-[#e8dcc4] transition-colors relative group cursor-pointer whitespace-nowrap">
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-px bg-[#e8dcc4] transition-all duration-300 group-hover:w-full"></span>
            </button>
            <div className="flex items-center gap-4 ml-4 pl-4 border-l border-gray-600">
              <a href="https://www.instagram.com/dighsk_/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center hover:text-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://soundcloud.com/dighsk" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center hover:text-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-music-2-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-black/95 backdrop-blur-sm border-t border-gray-800">
            <div className="px-4 py-6 space-y-4">
              <button onClick={() => scrollToSection('about')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                About
              </button>
              <button onClick={() => scrollToSection('sculptures')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Sculptures
              </button>
              <button onClick={() => scrollToSection('music')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Music
              </button>
              <button onClick={() => scrollToSection('video')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Video Works
              </button>
              <button onClick={() => scrollToSection('design')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Design
              </button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left py-2 text-sm font-light hover:text-[#e8dcc4] transition-colors cursor-pointer">
                Contact
              </button>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-700">
                <a href="https://www.instagram.com/dighsk_/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center hover:text-[#e8dcc4] transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="https://soundcloud.com/dighsk" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center hover:text-[#e8dcc4] transition-colors cursor-pointer">
                  <i className="ri-music-2-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Content */}
      <div className="pt-20 md:pt-24 pb-16 md:pb-24 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Back Button */}
          <button 
            onClick={handleBackToWorks}
            className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors mb-8 md:mb-12 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            <span>Back to Works</span>
          </button>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
            {/* Images */}
            <div className="lg:col-span-2 space-y-4 md:space-y-6">
              {sculpture.images.map((img, index) => (
                <div key={index} className="relative w-full h-auto flex items-center justify-center bg-black shadow-[0_4px_20px_rgba(0,0,0,0.4)]">
                  <img 
                    src={img}
                    alt={`${sculpture.title} ${index + 1}`}
                    className="w-full h-auto md:h-[800px] md:w-auto object-contain"
                  />
                </div>
              ))}
            </div>

            {/* Info */}
            <div className="lg:sticky lg:top-24 lg:self-start">
              <h1 className="text-3xl md:text-4xl font-light mb-4 text-[#e8dcc4]">{sculpture.title}</h1>
              <div className="mb-6 space-y-2 pb-6 border-b border-gray-700">
                <p className="text-sm text-gray-400">
                  <span className="text-[#e8dcc4]">Material:</span> {sculpture.material}
                </p>
                <p className="text-sm text-gray-400">
                  <span className="text-[#e8dcc4]">Year:</span> {sculpture.year}
                </p>
              </div>
              <p className="text-sm leading-relaxed text-gray-300 mb-8">
                {sculpture.description}
              </p>

              {/* Other Works */}
              <div className="mt-12 pt-8 border-t border-gray-700">
                <h3 className="text-lg font-light mb-4 text-[#e8dcc4]">Other Works</h3>
                <div className="space-y-4">
                  {sculptures.filter(s => s.id !== sculpture.id).slice(0, 3).map((s) => (
                    <button
                      key={s.id}
                      onClick={() => navigate(`/sculpture/${s.id}`)}
                      className="w-full group cursor-pointer text-left"
                    >
                      <div className="flex gap-4">
                        <div className="relative w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
                          <img 
                            src={s.images[0]}
                            alt={s.title}
                            className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-110"
                          />
                        </div>
                        <div className="flex-1">
                          <h4 className="text-sm font-light mb-1 group-hover:text-[#e8dcc4] transition-colors">{s.title}</h4>
                          <p className="text-xs text-gray-400">{s.material}</p>
                          <p className="text-xs text-gray-500">{s.year}</p>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#0a0a0a] py-12 md:py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-3 mb-4 md:mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/0f42d2ce-e038-4c14-a91d-0b039870b3a6.png" 
                  alt="Dighsk Logo" 
                  className="h-6 md:h-8 w-6 md:w-8 object-contain"
                />
                <span className="text-lg md:text-xl font-light tracking-wider">Dighsk</span>
              </div>
              <p className="text-xs md:text-sm text-gray-400 leading-relaxed">
                Structural Artist crossing boundaries through structure.
              </p>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-light mb-3 md:mb-4 text-[#e8dcc4]">Works</h4>
              <ul className="space-y-2">
                <li><button onClick={() => scrollToSection('sculptures')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Sculptures</button></li>
                <li><button onClick={() => scrollToSection('music')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Music</button></li>
                <li><button onClick={() => scrollToSection('video')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Videos</button></li>
                <li><button onClick={() => scrollToSection('design')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Design</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-light mb-3 md:mb-4 text-[#e8dcc4]">About</h4>
              <ul className="space-y-2">
                <li><button onClick={() => scrollToSection('about')} className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Biography</button></li>
                <li><a href="#" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Exhibitions</a></li>
                <li><a href="#" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Press</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-light mb-3 md:mb-4 text-[#e8dcc4]">Connect</h4>
              <ul className="space-y-2">
                <li><a href="https://www.instagram.com/dighsk_/" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Instagram</a></li>
                <li><a href="https://soundcloud.com/dighsk" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">SoundCloud</a></li>
                <li><a href="https://vimeo.com/dighsk" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-400 hover:text-[#e8dcc4] transition-colors cursor-pointer">Vimeo</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-xs md:text-sm text-gray-500 order-2 md:order-1">© 2025 Dighsk. All rights reserved.</p>
            <div className="flex items-center gap-4 md:gap-6 order-1 md:order-2">
              <a href="https://www.instagram.com/dighsk_/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base md:text-lg"></i>
              </a>
              <a href="https://soundcloud.com/dighsk" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-music-2-line text-base md:text-lg"></i>
              </a>
              <a href="https://vimeo.com/dighsk" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-video-line text-base md:text-lg"></i>
              </a>
              <a href="mailto:contact@dighsk.art" className="w-10 h-10 rounded-lg border border-gray-700 flex items-center justify-center hover:border-[#e8dcc4] transition-colors cursor-pointer">
                <i className="ri-mail-line text-base md:text-lg"></i>
              </a>
            </div>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-500 hover:text-[#e8dcc4] transition-colors cursor-pointer order-3">Powered by Readdy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
